import { Vector as VectorLayer } from 'ol/layer.js';
import VectorSource from 'ol/source/Vector.js';
import Feature from 'ol/Feature';
import { Fill, Stroke, Style, Circle, Text } from 'ol/style';

import { fromLonLat, get, transform } from 'ol/proj';
import Point from 'ol/geom/Point';
import { Location } from '../../model/location';
import { OlMap } from 'ol/Map';
import { NameFormatter } from 'src/app/util/name-formatter';

const source = new VectorSource({

});

export class LocationsLayer extends VectorLayer {

    constructor(options = {}, nameFormatter:NameFormatter) {
        super({
            ...options,
            source: source,        
            style: LocationsLayer.styleParser(nameFormatter)
        });
    }

    updateLocations(locations: Location[]){
        source.clear();

        source.addFeatures(locations.map(LocationsLayer.locationToFeature));
    }

    static locationToFeature(location: Location) {
        const x = parseFloat(location.coordinateX);
        const y = parseFloat(location.coordinateY);

        if (isNaN(x) || isNaN(y)) {
            return new Feature();
        }

        const feature = new Feature(new Point(fromLonLat([x, y])));
        feature.set('location', location);
        return feature;
    }

    static styleCache = {};

    static styleParser = (nameFormatter:NameFormatter) => (feature, resolution) => {
        const location = feature.get('location');

        const number = nameFormatter.format(location.name);

        const color = location.hasMalfunction ? 'rgba(255, 0, 0, 0.75)' : 'rgba(0, 128, 0, 0.75)';
        
        const key = `cache-${color}-${number}-${resolution}`

        if(!LocationsLayer.styleCache[key]){
            LocationsLayer.styleCache[key] = new Style({
                image: new Circle({
                    radius: Math.max(7 / (Math.sqrt(resolution*1.3)), 7),
                    fill: new Fill({
                        color
                    }),
                    stroke: new Stroke({
                      color: 'white'
                    }),
                }),
                text: new Text({
                    font: '12px Calibri,sans-serif',
                    fill: new Fill({ color: '#000' }),
                    stroke: new Stroke({
                      color: '#fff', width: 2
                    }),
                    offsetY: Math.min(-10 / (Math.sqrt(resolution*1.5)), -10),
                    text: number
                  })
            });
        }

        return LocationsLayer.styleCache[key];
    }
}
